import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-24 px-4 bg-brand-slate text-brand-cream" data-id="element-166">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-167">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-brand-navy mb-8" data-id="element-168">
          <AlertTriangleIcon className="w-8 h-8 text-brand-coral" aria-hidden="true" data-id="element-169" />
        </div>

        <span className="text-brand-lavenderDark font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-170">
          El problema real
        </span>

        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-10 text-white" data-id="element-171">
          La ansiedad a esta edad no es solo "estrés"
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-brand-creamDark leading-relaxed text-left md:text-center" data-id="element-172">
          <p data-id="element-173">
            Es una traición física. Es sentir que tu cuerpo se dispara en el
            supermercado, en una cena familiar o en plena madrugada sin una
            razón lógica.
          </p>
          <p data-id="element-174">
            Vives con el miedo constante al "próximo ataque". Esa sensación de
            vulnerabilidad te ha robado la confianza para viajar, para disfrutar
            de tus hijos o simplemente para descansar una noche entera sin
            sobresaltos.
          </p>
        </div>
      </div>
    </section>;
}